import { httpClient } from '@/shared/lib/axios';

import type { ImageInfo } from './image.types';

/**
 * - `avatars` - Аватар профиля
 * - `logos` - Лого
 **/
export type ImagePrefix = 'avatars' | 'logos' | 'drugs';

export type UploadImageParams = {
  file: File;
  prefix: ImagePrefix;
};

export const ImageApi = {
  uploadImage: async (params: UploadImageParams) => {
    const { file, prefix } = params;

    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('prefix', prefix);

    const { data } = await httpClient.post<ImageInfo>('image', formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    });

    return data;
  },
};
